import { Lang } from './common';

export interface PcodeRenderData {
    type: BannerViewType;
    size?: {
        width: number;
        height: number;
    };
    ads: PcodeAds[];
    isSquareFormat?: boolean;
}

// todo - описание типа неполное
export interface PcodeRenderDataCanvas {
    width: number;
    height: number;
    options: PcodePreviewOptions;
    elements: PcodeCanvasItem[];
    mediaSets: {
        [key: string]: PcodeCanvasMediaSet;
    };
    bundle: {
        name: CanvasViewType;
        version: number;
    };
}

export interface PcodePreviewOptions {
    backgroundColor: string;
    borderColor: string;
    hasAnimation: boolean;
    isAdaptive?: boolean;
}

export interface PcodeCanvasMediaSet {
    items: PcodeCanvasMediaSetItem[];
}

// todo - скорее всего здесь есть и другие типы
export type PcodeCanvasMediaSetItem = PcodeCanvasImageSet;

export interface PcodeCanvasImageSet {
    type: 'image';
    items: PcodeCanvasImageSetItem[];
}

export interface PcodeCanvasImageSetItem {
    url: string;
    width: number;
    height: number;
    alias: string;
}

type PcodeCanvasItem =
    | PcodeCanvasImage
    | PcodeCanvasHeadline
    | PcodeCanvasButton
    | PcodeCanvasFade
    | PcodeCanvasLogo
    | PcodeCanvasDescription
    | PcodeCanvasDomain
    | PcodeCanvasSpecial;

export interface PcodeCanvasImage {
    type: 'image';
    available: boolean;
    mediaSet: string;
    options: { width: number; height: number };
}

export interface PcodeCanvasHeadline {
    type: 'headline';
    available: boolean;
    options: {
        placeholder: string;
        content: string;
        color: string;
    };
    maxLength: number;
}

export interface PcodeCanvasButton {
    type: 'button';
    available: boolean;
    options: {
        placeholder: string;
        content: string;
        backgroundColor: string;
        color: string;
    };
}

export interface PcodeCanvasFade {
    type: 'fade';
    available: boolean;
    options: { color: string };
}

export interface PcodeCanvasLogo {
    type: 'logo';
    available: boolean;
    mediaSet: string;
    options: { width: number; height: number };
}

export interface PcodeCanvasDescription {
    type: 'description';
    available: boolean;
    options: {
        placeholder: string;
        content: string;
        color: string;
    };
    maxLength: number;
}

export interface PcodeCanvasDomain {
    type: 'domain';
    available: boolean;
    options: {
        placeholder: string;
        content: string;
        color: string;
    };
}

export interface PcodeCanvasSpecial {
    type: 'special';
    available: boolean;
    options: {
        placeholder: string;
        content: string;
        color: string;
        backgroundColor: string;
    };
}

interface PcodeAdsImageSmartCenter {
    h: number;
    w: number;
    x: number;
    y: number;
    ratio?: string;
}

interface PcodeAdsImageSettings {
    ColorWizButton?: string;
    ColorWizButtonText?: string;
    ColorWizBack?: string;
    ColorWizBackRight?: string;
    ColorWizText?: string;
    'smart-centers'?: PcodeAdsImageSmartCenter[];
}

export type PcodeAdsImage = [string, number, number, PcodeAdsImageSettings?];

export interface PcodeAds {
    // Идентификатор объявления (допустимо заменить его фейковым)
    adId: string;
    // Заголовок объявления
    title: string;
    // Текст объявления
    body: string;
    // Ссылка на сайт (должна быть обязательно указана при указании поля domain).
    url: string;
    // Текст ссылки на сайт (если не указан - ссылка не выводится)
    domain: string;
    // Домен в punycode (используется для формирования адреса favicon следующим образом //favicon.yandex.net/favicon/ + punyDomain).
    // favicon появляется только если указаны поля domain и punyDomain
    punyDomain: string;
    // Флаги баннера
    banner_flags: string; // флаг1,флаг2,флаг3
    // Язык
    lang: Lang;

    images?: PcodeAdsImage[];

    // Идентификатор объявления, используемый в механизм отправляющем сигнал в движок о том,
    // что объявление попало в область видимости страницы и пользователь его увидел
    linkTail: string;
    dynamic_disclaimer: string;
    // Возрастное ограничение (например, 18+)
    age: string;
    // Текст предупреждения объявления
    warning: string;
    // Массив сайтлинков
    sitelinks: string[];

    // fav икнока
    favicon: string; // ?
    // URL визитки
    vcardUrl: string; // ? это previewUrl
    // Данные объявления для РМП
    addInfo?: PcodeAddInfo;
}

interface PcodeAddInfo {
    // Тип объявления (пока может быть только 'mobile-app')
    type: 'mobile-app';
    // Рейтинг приложения
    rating: string;
    // Стоимость приложения
    price: string;
    // Трехбуквенный ISO-код валюты (пример, RUB)
    price_currency_code: string;
    // Символ валюты, который и будет отрисовываться в объявлении (пример, р.).
    // При этом на уровне партнерского кода, если price_currency_code = RUB, то символ рубля переопределяется на '.р'
    price_currency_symbol: string;
    // Рейтинг приложения
    review_count: string;
    // Иконки приложения
    icon: object[]; // ?
    // Название кнопки без цены
    call_to_action: string;
    // Ссылка на скачивание приложения
    call_to_action_url: string;
}

export enum BannerViewType {
    adaptive0418 = 'adaptive0418',
    videoAdditionPreview = 'video-addition-preview',
    plainImagePreview = 'plainImagePreview',
    html5CreativePreview = 'html5-preview'
}

// типы для креативов взяты из https://github.yandex-team.ru/any/concept/tree/master/examples/docs
// возможно тут не все типы
export enum CanvasViewType {
    bigPicButton = 'media-banner_theme_big-pic-button',
    divided = 'media-banner_theme_divided',
    gif = 'media-banner_theme_gif',
    picButtonColorBackground = 'media-banner_theme_pic-button-color-background',
    speedy = 'media-banner_theme_speedy',
    twin = 'media-banner_theme_twin',
    wine = 'media-banner_theme_wine'
}
